import { Component } from '@angular/core';

@Component({
  selector: 'pdf-match-diacritics',
  templateUrl: './pdf-match-diacritics.component.html',
  styleUrls: [],
})
export class PdfMatchDiacriticsComponent {}
